import {TooltipItem} from 'chart.js';
import {Context} from 'chartjs-plugin-datalabels';
import {Color, Options} from 'chartjs-plugin-datalabels/types/options';

import {defaultTooltipOptions} from '../chart-const';

import {ChartJsRadarOptionsType, RadarLabelType} from './radar-chart-type';

export const radarChartOptions: ChartJsRadarOptionsType = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
        // eslint-disable-next-line id-length
        r: {
            max: 105,
            ticks: {
                display: false,
                stepSize: 21,
            },
            pointLabels: {
                callback: (label: unknown): string => {
                    const radarLabel: RadarLabelType = label as RadarLabelType;

                    if (typeof radarLabel === 'string') {
                        return radarLabel;
                    }

                    return radarLabel.name;
                },
            },
        },
    },
    plugins: {
        legend: {
            display: true,
            align: 'start',
            labels: {
                boxWidth: 16,
                boxHeight: 16,
            },
        },
        tooltip: {
            ...defaultTooltipOptions,
            position: 'nearest' as const,
            callbacks: {
                title(tooltipItems: Array<TooltipItem<'radar'>>): string {
                    const radarLabel: RadarLabelType = tooltipItems[0]?.label as RadarLabelType;

                    if (typeof radarLabel === 'string') {
                        return radarLabel;
                    }

                    return radarLabel.name;
                },
                label(context: TooltipItem<'radar'>): string {
                    const dataSetLabel: string = context.dataset.label || '';

                    const radarLabel: RadarLabelType = context.label as RadarLabelType;

                    if (typeof radarLabel === 'string') {
                        return `${dataSetLabel}: ${context.formattedValue}`;
                    }

                    const {getTooltipFormatted} = radarLabel;

                    return `${dataSetLabel}: ${getTooltipFormatted(Number(context.raw))}`;
                },
            },
        },
        datalabels: {
            display: false,
        },
    },
};

export const radarChartDataLabelsOptions: Options = {
    backgroundColor: (context: Context): Color | null => {
        if (typeof context.dataset.borderColor === 'string') {
            return context.dataset.borderColor;
        }

        return null;
    },
    color: 'white',
    font: {
        weight: 'bold',
    },
    formatter: Math.round,
    padding: 2,
    borderRadius: 2,
};

export const radarChartDashLine = [10, 5];
